import {
    getLatestNewsRequest,
    getNewsListRequest,
    getNewsBySlugRequest,
    getNewsByCategoryRequest,
    getNewsStatsRequest,
} from '../../../services/network/common/news';

class NewsService {
    async getLatestNews(lang, limit = 3) {
        return await getLatestNewsRequest(lang, limit);
    }

    async getNewsList(params) {
        return await getNewsListRequest(params);
    }

    async getNewsBySlug(slug, lang) {
        return await getNewsBySlugRequest(slug, lang);
    }

    async getNewsByCategory(category, lang, limit, offset) {
        return await getNewsByCategoryRequest(category, lang, limit, offset);
    }

    async getNewsStats() {
        return await getNewsStatsRequest();
    }
}

export default new NewsService();
